import { useCallback } from 'react'
import { useCopyVoiceConfigModal } from '../../../modals/CopyVoiceConfigModal'

export function useActions() {
  const { show: showCopyVoiceConfigModal } = useCopyVoiceConfigModal()

  const onCopy = useCallback(() => {
    showCopyVoiceConfigModal()
  }, [showCopyVoiceConfigModal])

  return {
    onCopy,
  }
}
